import {
  RadioGroup as ChakraRadioGroup,
  FormControl,
  FormLabel,
  Radio,
  Stack,
} from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

import { CompanyCheckbox } from '@/containers/forms/company-checkbox'
import { CompanyCheckboxGroup } from '@/containers/forms/CompanyCheckboxGroup'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsurers } from '@/hooks'
import { getLogo } from '@/utils/companiesLogos'

export const ParametersForm = () => {
  const { setValue, getValues, watch } = useFormContext<InsuranceParamsDto>()

  const { data: allAddonInsurersData } = useInsurers(true, false)

  const allAddonInsurers = allAddonInsurersData?.data ?? []
  const selectedAddonInsurers = watch('baseParams.addonInsurers') ?? []
  const isSelectedAllAddonInsurers = selectedAddonInsurers.length === allAddonInsurers?.length

  useEffect(() => {
    if (allAddonInsurers.length > 0 && getValues('baseParams.addonInsurers')?.length == 0)
      setValue('baseParams.addonInsurers', allAddonInsurers.map(({ id }) => id))
  }, [allAddonInsurers.length])

  return (
    <>

      <FormRow>
        {allAddonInsurers.length > 0 &&
          <FormControl sx={{ gap: 8 }}>
            <FormLabel>Vybrané pojišťovny</FormLabel>

            <ChakraRadioGroup
              onChange={(e) => {
                setValue('baseParams.addonInsurers', e == '1'
                  ? [...allAddonInsurers?.map(x => x.id) ?? []]
                  : [])
              }}
              value={isSelectedAllAddonInsurers ? '1' : '0'}
            >
              <Stack
                direction='row'
                spacing={{
                  base: 4,
                  lg: 8,
                }}
              >
                <Radio value='1'>
                  Všechny dostupné
                </Radio>
                <Radio value='0'>
                  Vlastní výběr
                </Radio>
              </Stack>
            </ChakraRadioGroup>

            {!isSelectedAllAddonInsurers && (
              <CompanyCheckboxGroup name="baseParams.addonInsurers">
                {allAddonInsurers.map(({ id, name }) => (
                  <CompanyCheckbox key={id} value={id} logo={getLogo(id)}>
                    <>{name}</>
                  </CompanyCheckbox>
                ))}
              </CompanyCheckboxGroup>
            )}
          </FormControl>
        }
      </FormRow>
    </>
  )
}
